import React from "react";

const MultipleForms = (props) => {
    const handleChange = (e) => {
        const files = Array.from(e.target.files);
        const pdfs = files.filter(file => file.type === "application/pdf");
        props.updateValue(pdfs);
    }

    return (
        <>
            <div className="input-field" style={{ height: "auto" }}>
                <div className="top-input">
                    { props.top } 
                    {
                        props.star

                        ?

                        <span className="required-star">
                            *
                        </span>

                        :

                        <>
                        </>
                    }
                </div>
                <div className="pdf-upload-container" style={{ height: "30px" }}>
                    <input ref={props.pdfsRef} type="file" className="pdf-choose" onChange={handleChange} required={ props.required } accept="application/pdf" multiple={true}/>
                </div>
            </div>
        </>
    );
}

export default MultipleForms;